import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from '../../../components/Modal'
import moment from 'moment'
import 'moment/locale/he'
//import { ContactProps, MessageProps } from '../../../shared/prop-types/ChatProps';
moment.locale('he')

export default class ChatBubble extends PureComponent {
    static propTypes = {
        message: {}, //MessageProps.isRequired,
        active: PropTypes.bool,
    };

    static defaultProps = {
        active: false,
    };

    render() {
        //require('moment/locale/he');

        const {message, active} = this.props;
        const bubbleClass = classNames({
            chat__bubble: true,
            'chat__bubble--active': active,
        });

        let name = '';

        if(message.isStore !== undefined)  {
            if(message.isStore === 1) {
                name = 'משווק/חנות: ' + message.name;
            }
            else {
                name = 'שם המתפעל/ת: ' + message.name;
            }
        }
        else {
            name = message.name;
        }

        let date = moment(message.date).format('llll');
        if(date === 'Invalid date') date = message.date;

        return (
            <div className={bubbleClass}>


                <div>
                    <p className="chat__bubble-date" style={{left: 0}}>{date}</p>
                    {/*<p className="chat__bubble-date" style={{left: 0}}>{message.date}</p>*/}
                </div>
                <div className="chat__bubble-message-wrap">
                    <p className="chat__bubble-contact-name" style={{textDecoration: 'underline'}}>{name}</p>
                    <p className="chat__bubble-message">{message.message}</p>
                </div>
                {this.props.isDelete && <div>
                    <Modal color='danger' title='Are you sure!'
                           approve={() => this.props.deleteMessage(this.props.mesId)}
                           message={'Delete this message?'}>

                        <i className="fa fa-trash-o" aria-hidden="true"
                           style={{ fontSize: '20px', marginTop: '15px', cursor: 'pointer', marginRight: '20px'}}></i>
                    </Modal>
                </div>}
            </div>
        );
    }
}
